/**
 * Built-in first-hello templates. Leaders see these when no templates have been
 * created in /admin yet; admins can seed them into Firestore from the settings page
 * and edit from there. Variables: {{firstName}} {{hebrewName}} {{leaderName}}.
 */
import type { OutreachTemplate } from '@/types/outreach';

export type StarterTemplate = Pick<
  OutreachTemplate,
  'id' | 'title' | 'body' | 'language' | 'isActive' | 'sortOrder'
> & {
  /** Suggested first when the leader invited the member. */
  suggestWhenInviter?: boolean;
};

export const STARTER_OUTREACH_TEMPLATES: StarterTemplate[] = [
  {
    id: 'starter-welcome',
    title: 'Welcome',
    body: "Shalom {{firstName}}, welcome to Spirit of Shabbat! I'm {{leaderName}}. I'm so glad you joined us. Is there anything you're hoping to find here, or anything I can help with?",
    language: 'en',
    isActive: true,
    sortOrder: 1,
  },
  {
    id: 'starter-short',
    title: 'Short and warm',
    body: "Hi {{firstName}}, {{leaderName}} here. Welcome to Spirit of Shabbat. We're really glad you're part of the community. Let me know if I can help with anything.",
    language: 'en',
    isActive: true,
    sortOrder: 2,
  },
  {
    id: 'starter-inviter',
    title: 'From the inviter',
    body: "Shalom {{firstName}}, it's {{leaderName}}. I'm so happy you accepted my invitation and joined us. Please tell me if there's anything I can do to help you settle in.",
    language: 'en',
    isActive: true,
    sortOrder: 3,
    suggestWhenInviter: true,
  },
];
